import { REST } from 'helpers/api';

import { getCancelExportEndpoint } from 'services/api/exporterEndpoints';

export async function cancelExportApiRequest(exportFileId) {
  return REST.post({
    endpoint: getCancelExportEndpoint(exportFileId),
  });
}
